import { render, staticRenderFns } from "./insta-feed.vue?vue&type=template&id=29380b34&scoped=true&"
import script from "./insta-feed.vue?vue&type=script&lang=js&"
export * from "./insta-feed.vue?vue&type=script&lang=js&"
import style0 from "./insta-feed.vue?vue&type=style&index=0&id=29380b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29380b34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('29380b34', component.options)
    } else {
      api.reload('29380b34', component.options)
    }
    module.hot.accept("./insta-feed.vue?vue&type=template&id=29380b34&scoped=true&", function () {
      api.rerender('29380b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/insta-feed.vue"
export default component.exports